import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3886aa51"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "flex flex-col box-shadow-profile px-0 lg:px-20 border" }

import { markRaw, computed } from "vue";
import { accountStore } from "@/stores/account";

import TabTemplate from "@/components/templates/TabTemplate.vue";
import ShareholderCard from "@/components/molecules/ShareholderCard.vue";
import ShareholderIdentificationTab from "@/views/tabs/ShareholderIdentificationTab.vue";
import ShareholderNotificationSettingsTab from "@/views/tabs/ShareholderNotificationSettingsTab.vue";
import ShareholderAccountTab from "@/views/tabs/ShareholderAccountTab.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'MyPerfilView',
  setup(__props) {

const accountStr = accountStore();
const activeAccount = computed(() => accountStr.activeAccount);


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(ShareholderCard, { class: "border-b-[#9BB441] border-b-[20px] px-5" }),
    (_unref(activeAccount) != 0)
      ? (_openBlock(), _createBlock(TabTemplate, {
          key: 0,
          class: "col-span-8",
          tabs: [
        {
          name: 'Cuentas ',
          view: markRaw(ShareholderAccountTab),
        },
        { 
          name: 'Perfil', 
          view: markRaw(ShareholderIdentificationTab) 
        },
        {
          name: 'Notificaciones',
          view: markRaw(ShareholderNotificationSettingsTab),
        },
      ]
        }, null, 8, ["tabs"]))
      : _createCommentVNode("", true),
    (_unref(activeAccount) == 0)
      ? (_openBlock(), _createBlock(TabTemplate, {
          key: 1,
          class: "col-span-8",
          tabs: [
        {
          name: 'Cuentas ',
          view: markRaw(ShareholderAccountTab),
        },
        { name: 'Perfil', view: markRaw(ShareholderIdentificationTab) },
      ]
        }, null, 8, ["tabs"]))
      : _createCommentVNode("", true)
  ]))
}
}

})